import axios, { AxiosError } from 'axios';
import { Api } from '../axiosApi';

export type TCaixaTurnoStatus =
  | { aberto: true; dataabertura: string; valorabertura: number }
  | { aberto: false };

interface ErrorResponse {
  errors?: { default: string };
  error?: { default: string };
}

const extractError = (error: unknown): Error => {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError<ErrorResponse>;
    const message = axiosError.response?.data?.errors?.default || axiosError.response?.data?.error?.default;
    if (message) return new Error(message);
    if (axiosError.request) return new Error('Nenhuma resposta do servidor');
    return new Error(axiosError.message);
  }
  return new Error('Erro inesperado');
};

// Status da sessão de qualquer conta escolhida no backoffice (ex.: chip na
// tela de Conciliação) — sem precisar estar logado como o operador dono do
// caixa. Abrir/fechar sessão por aqui (fora do PDV) não tem tela própria
// hoje; os endpoints de backend continuam existindo (AbrirAdmin.ts/
// FecharAdmin.ts) se algum dia precisar de novo.
const getStatus = async (idconta: string): Promise<TCaixaTurnoStatus | Error> => {
  try {
    const { data } = await Api.get('/statusturnoadmin', { params: { idconta } });
    return data;
  } catch (error) {
    return extractError(error);
  }
};

export const CaixaTurnoAdminService = {
  getStatus,
};
